// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"LoginSignup_formContainer__PnoHV","formLogo":"LoginSignup_formLogo__3TY2x","formInput":"LoginSignup_formInput__1PiDQ","btnn":"LoginSignup_btnn__2CxE5"};